import { useState } from 'react';
import { PrimaryButton } from '../../ui/Button/Buttons';
import { submitRequirementEvidence } from '../../../services/RequirementStepsService';
import { SubmittedEvidenceItem } from '../../../types/RequirementSteps.types';
import {
  evidenceField,
  formatEvidenceDate,
  latestEvidence
} from '../../../utils/evidenceHistory';

type RequirementEvidenceAttestationProps = {
  actionId: string;
  submittedEvidence?: SubmittedEvidenceItem[] | null;
  onSubmitted: () => void;
};

export function RequirementEvidenceAttestation({
  actionId,
  submittedEvidence,
  onSubmitted
}: RequirementEvidenceAttestationProps) {
  const [submitting, setSubmitting] = useState(false);

  const latest = latestEvidence(submittedEvidence);
  const latestAttestedAt = evidenceField(latest, 'attestedAt');
  const latestAttestedBy = evidenceField(latest, 'attestedById');

  const handleAttest = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await submitRequirementEvidence(actionId, {
        attestationDate: new Date().toISOString()
      });
      onSubmitted();
    } catch (submitError) {
      console.error('Failed to submit attestation evidence:', submitError);
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col gap-2 mt-2">
      {latestAttestedAt && (
        <div className="text-xs text-gray-600">
          <span className="font-medium text-gray-700">Last attested</span>{' '}
          {formatEvidenceDate(latestAttestedAt)}
          {latestAttestedBy ? ` by ${latestAttestedBy}` : ''}
        </div>
      )}
      <div className="flex justify-end">
        <PrimaryButton size="sm" onClick={handleAttest} disabled={submitting}>
          {submitting ? 'Submitting...' : 'Attest'}
        </PrimaryButton>
      </div>
    </div>
  );
}
